var array = Array.prototype;

export var slice = array.slice;
export var map = array.map;



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3/node_modules/d3-array/src/array.js
// module id = 191
// module chunks = 0